function NoIndexMeta() {
	return <meta name="robots" content="noindex, nofollow" />;
}

export default NoIndexMeta;
